import React, { useRef, useState, useEffect } from "react";
import { Stage, Layer, Image, Rect } from "react-konva";
import apiService from "../../service";
import { useParams } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import PreviewComponent from "../Preview/Preview";

const ReceiptPreview = () => {
  const { id } = useParams();
  const [dataAvailable, setDataAvailable] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await apiService.getreceiptDataId(id);
        setDataAvailable(data);
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();
  }, []);

  console.log(dataAvailable, "dataAvailable");
  const breadCrumbArray = [
    {
      name: "Receipt",
      color: "#000000",
      underline: "none",
      href: "/doc-ai/receipt",
    },
    {
      name: dataAvailable?.file_name,
      color: "#767676",
      underline: "none",
    },
  ];

  return (
    <>
      <PreviewComponent
        dataAvailable={dataAvailable}
        setDataAvailable={setDataAvailable}
        breadCrumbNames={breadCrumbArray}
        id={id}
      />
    </>
  );
};

export default ReceiptPreview;
